// A screenshot of the restaurant's shop in the platform agent's panel (contracts §5 card shop_screenshot, §9).
export default {
  title: {
    phone: 'Magazinul dvs. pe telefon',
    desktop: 'Magazinul dvs. pe computer',
  },
  loading: 'Se încarcă captura de ecran',
  failed: 'Captura de ecran nu a putut fi încărcată.',
};
